const MONGO_OID_RE = /^[a-fA-F0-9]{24}$/;
const ZERO_OID = "000000000000000000000000";

export function normalizeOrderLineObjectId(value: unknown): string {
  if (value == null) return "";
  if (typeof value === "object") {
    const oid = (value as { $oid?: string }).$oid;
    if (oid) return String(oid).trim();
    const str = (value as { toString?: () => string }).toString?.();
    return str && str !== "[object Object]" ? String(str).trim() : "";
  }
  return String(value).trim();
}

export function isOrderLineObjectId(value: unknown): boolean {
  const s = normalizeOrderLineObjectId(value);
  return MONGO_OID_RE.test(s) && s !== ZERO_OID;
}

export function collectOrderLineObjectIds(
  ...lists: Array<Array<{ _id?: unknown; line_item_id?: unknown }> | null | undefined>
): Set<string> {
  const ids = new Set<string>();
  for (const list of lists) {
    for (const row of list || []) {
      const id =
        normalizeOrderLineObjectId(row._id) || normalizeOrderLineObjectId(row.line_item_id);
      if (isOrderLineObjectId(id)) ids.add(id);
    }
  }
  return ids;
}

export function newOrderLineObjectId(existingIds?: Iterable<string>): string {
  const taken = existingIds instanceof Set ? existingIds : new Set(existingIds || []);
  let id = "";
  do {
    const bytes = new Uint8Array(12);
    crypto.getRandomValues(bytes);
    id = Array.from(bytes, (b) => b.toString(16).padStart(2, "0")).join("");
  } while (taken.has(id) || id === ZERO_OID);
  return id;
}

export function salesLineIdentityKey(row: {
  _id?: unknown;
  line_item_id?: unknown;
  productId?: unknown;
  variantId?: unknown;
  product_id?: unknown;
  variant_id?: unknown;
}): string {
  const id =
    normalizeOrderLineObjectId(row._id) || normalizeOrderLineObjectId(row.line_item_id);
  if (isOrderLineObjectId(id)) return id;
  return `${String(row.productId ?? row.product_id ?? "")}:${String(row.variantId ?? row.variant_id ?? "")}`;
}
